import React, { useEffect, useState } from 'react'

import "../styles/documentViewer.scss";
import { AppConfig } from '../config/appConfig';
import moment from 'moment';
import { Alert, Button } from '@mui/material';
import { Buffer } from 'buffer';
import { IVendorDocument } from '../types/document';


export interface IVendorDocumentViewerProps {
	document: IVendorDocument | undefined,
	profileName: string
}

const VendorDocumentViewer: React.FunctionComponent<IVendorDocumentViewerProps> = ({ document, profileName }) => {

	//For viewing documents
	const [previewUrl, setPreviewUrl] = useState("");
	const [downloadUrl, setDownloadUrl] = useState("");
	const [fileName, setFileName] = useState("");
	const [title, setTitle] = useState("");

	useEffect(() => {
		loadVendorDocument();
	}, [document])

	const loadVendorDocument = async () => {
		if (document && document.content) {
			setTitle(`${profileName} BOL - ${document.filename.replace('rw-', '').replace('.pdf', '')}`);
			if (document.filename) setFileName(document.filename);
			const blob = new Blob([Buffer.from(document.content, "base64")], {
				type: document.contentType 
			});
			const blobUrl = URL.createObjectURL(blob);
			setDownloadUrl(blobUrl);

			if (AppConfig.viewableDocumentTypes.filter((item) => { return item == document.contentType?.toLowerCase() ? true : false; }).length > 0) {
				setPreviewUrl(blobUrl);
			}
			else {
				setPreviewUrl(undefined);
			}
		}
	}
	return (
		<div className="hwi-document-viewer">
			<section className="search-bar">
				<div className="search-header">
					<div className="title">
						{title}
					</div>
					<div className="controls">
						<a href={downloadUrl} target="_blank"><Button variant='outlined'>Open In New Tab</Button></a>
						<a href={downloadUrl} download={title}><Button variant='outlined'>Download</Button></a>
					</div>
				</div>
			</section>
			<div className="document-wrapper">
				<Alert className="alert" severity="info" >
					Depending on the document type and your browser settings you may not be able to preview documents in the application. If your document does not load below, please use the Download button to download a local copy.
				</Alert>
				{previewUrl &&
					<iframe className="document-frame" src={previewUrl}></iframe>
				}
			</div>
		</div>
	)
}

export default VendorDocumentViewer;